import type { AppSettings, StorageSummary } from "../types/app";
import { StoragePanel } from "../components/StoragePanel";

interface Props {
  settings: AppSettings;
  storage: StorageSummary | null;
  onSettings: (patch: Partial<AppSettings>) => Promise<void>;
  onRefresh: () => void;
}

export function ApiSettingsPage({ settings, storage, onSettings, onRefresh }: Props) {
  return (
    <main className="screen">
      <h1>API・費用設定</h1>
      <StoragePanel summary={storage} onRefresh={onRefresh} />
      <section className="panel">
        <label className="checkbox"><input data-testid="live-enabled" type="checkbox" checked={settings.liveModeEnabled} onChange={(event) => void onSettings({ liveModeEnabled: event.target.checked, selectedMode: event.target.checked ? settings.selectedMode : "low-cost" })} /> Liveモードを有効化</label>
        <label>選択モード
          <select value={settings.selectedMode} onChange={(event) => void onSettings({ selectedMode: event.target.value as AppSettings["selectedMode"] })}>
            <option value="low-cost">低コストモード</option>
            <option value="live" disabled={!settings.liveModeEnabled}>Liveモード</option>
          </select>
        </label>
        <label>1回の最大会話時間<input type="number" min="1" max="30" value={settings.maxConversationMinutes} onChange={(event) => void onSettings({ maxConversationMinutes: Number(event.target.value) })} /></label>
        <label>1日の最大Live利用時間<input type="number" min="1" max="240" value={settings.dailyLiveLimitMinutes} onChange={(event) => void onSettings({ dailyLiveLimitMinutes: Number(event.target.value) })} /></label>
        <label>最大返答文字数<input type="number" min="120" max="1800" value={settings.maxResponseChars} onChange={(event) => void onSettings({ maxResponseChars: Number(event.target.value) })} /></label>
        <p>利用量表示と時間制限は端末内の目安です。課金上限の最終防衛手段にはOpenAI側のUsage LimitやProject Budgetを使ってください。</p>
      </section>
    </main>
  );
}
